export default class Model {

	constructor(data) {
		this.hasWritePermission = data ? data.hasWritePermission : false;
	}

	build() {
		return this;
	}

	static buildListOfModels(items) {
		return _.map(items, (item) => {
			return item.build();
		});
	}
}


// WEBPACK FOOTER //
// ./modules/distribution/core/models/Model.js